export type FieldConfig = {
    key: string;          // must match register(key) / FormData key
    label: string;        // shown in the email
    required?: boolean;
};

export type FormConfig = {
    id: string;            // used in the URL: /api/forms/[id]
    title: string;         // email subject/heading
    toEmail: string;       // where this form's mail goes
    fields: FieldConfig[];
    fileField?: string;    // name of file input, if any
};

export const FORM_CONFIGS: Record<string, FormConfig> = {
    contact: {
        id: "contact",
        title: "New Quotation Request",
        toEmail: process.env.CONTACT_TO_EMAIL!,
        fields: [
            { key: "fullName", label: "Name", required: true },
            { key: "companyName", label: "Company", required: true },
            { key: "businessEmail", label: "Email", required: true },
            { key: "phoneNumber", label: "Phone", required: true },
            { key: "country", label: "Country", required: true },
            { key: "serviceRequired", label: "Service", required: true },
            { key: "productCategory", label: "Category", required: true },
            { key: "estimatedQuantity", label: "Quantity" },
            { key: "message", label: "Message", required: true },
        ],
        fileField: "referenceFile",
    },

    generalContact: {
        id: "generalContact",
        title: "New Contact Message",
        toEmail: process.env.GENERAL_CONTACT_TO_EMAIL!,
        fields: [
            { key: "name", label: "Name", required: true },
            { key: "email", label: "Email", required: true },
            { key: "reason", label: "Reason" },
            { key: "message", label: "Message", required: true },
        ],
    },

    productEnquiry: {
        id: "productEnquiry",
        title: "New Product Enquiry",
        toEmail: process.env.PRODUCT_ENQUIRY_TO_EMAIL!,
        fields: [
            { key: "productTitle", label: "Product", required: true },
            { key: "productCategory", label: "Category" },
            { key: "name", label: "Full Name", required: true },
            { key: "email", label: "Email", required: true },
            { key: "company", label: "Company", required: true },
            { key: "phone", label: "Phone", required: true },
            { key: "quantity", label: "Estimated Quantity" },
            { key: "message", label: "Message", required: true },
        ],
        // no fileField — this form has no upload
    },

    // 🔽 Add your other 3 forms here, e.g.:
    // careers: {
    //   id: "careers",
    //   title: "New Job Application",
    //   toEmail: process.env.CAREERS_TO_EMAIL!,
    //   fields: [
    //     { key: "applicantName", label: "Name", required: true },
    //     { key: "position", label: "Position Applied For", required: true },
    //     { key: "experience", label: "Years of Experience" },
    //   ],
    //   fileField: "resume",
    // },
    // newsletter: {
    //   id: "newsletter",
    //   title: "Newsletter Signup",
    //   toEmail: process.env.MARKETING_TO_EMAIL!,
    //   fields: [{ key: "email", label: "Email", required: true }],
    // },
    // partnership: {
    //   id: "partnership",
    //   title: "Partnership Enquiry",
    //   toEmail: process.env.PARTNERSHIPS_TO_EMAIL!,
    //   fields: [
    //     { key: "orgName", label: "Organization", required: true },
    //     { key: "proposal", label: "Proposal", required: true },
    //   ],
    // },
};